import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Itememissio from './Itememissio';
import styles from './properesemissions.module.scss';

export default function ProperesEmissions(props) {
    let { titolBloc, className, items } = props;
    items = __isEmpty(items?.[0]?.item) ? [] : items[0].item;

    const stylesProperesEmissions = clsx({
        [styles.properesEmissions]: true,
        [styles.noItems]: __isEmpty(items),
        [styles[className]]: !__isEmpty(className)
    });

    const mostraEntradeta = (items) => {
        if (items.length > 1) {
            if (items[0].entradeta === items[1].entradeta) {
                return false;
            }
        }
        return true;
    };

    const getEmissio = () => {
        const mostrarEntradeta = mostraEntradeta(items);
        return items.map((item) => (
            <Itememissio
                key={'resultat_' + '_' + item.data_emissio + '_' + item.titol}
                titolEmissio={!__isEmpty(item.capitols) ? item.capitols[0]?.desc : ''}
                entradeta={mostrarEntradeta && item.entradeta}
                data_emissio={item.data_emissio}
                codiEspectador={item.codis_etics}
                canal={item.canals?.[0]}
                emissora={item.emissora}
                drets={item.drets}
            />
        ));
    };

    return (
        <div className={stylesProperesEmissions}>
            {!__isEmpty(items) && <span className={styles.titolBloc}>{titolBloc}</span>}
            <div>{getEmissio()}</div>
        </div>
    );
}
